import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
const placeholderUrl = 'https://placeholder.supabase.co';
const placeholderAnonKey = 'placeholder';

function readValidSupabaseUrl(value: string | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed || trimmed.includes('placeholder')) return null;

  try {
    return new URL(trimmed).toString().replace(/\/$/, '');
  } catch {
    return null;
  }
}

export function getSupabaseClientConfig(input: {
  url: string | undefined;
  anon: string | undefined;
}) {
  const validUrl = readValidSupabaseUrl(input.url);
  const anonKey = input.anon?.trim() || null;
  const isConfigured = Boolean(validUrl && anonKey);

  return {
    isConfigured,
    clientUrl: isConfigured && validUrl ? validUrl : placeholderUrl,
    clientAnonKey: isConfigured && anonKey ? anonKey : placeholderAnonKey,
  };
}

const supabaseConfig = getSupabaseClientConfig({ url, anon });
export const isSupabaseConfigured = supabaseConfig.isConfigured;

if (!isSupabaseConfigured) {
  console.warn(
    '[supabase] Using placeholder credentials — auth will not work.\n' +
      'Add real VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to .env.local at the repo root',
  );
}

export const supabase = createClient(supabaseConfig.clientUrl, supabaseConfig.clientAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
